"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getAdjustmentDetails = getAdjustmentDetails;
exports.getBudgetBillingPlan = getBudgetBillingPlan;
exports.getCurrentBudgetBillingPlan = getCurrentBudgetBillingPlan;
exports.saveNewBudgetBillingPlan = void 0;
var _RestHelper = _interopRequireWildcard(require("../../utils/RestHelper"));
var _CacheHandler = _interopRequireDefault(require("../../utils/CacheHandler"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
function getCurrentBudgetBillingPlan(contractAccountId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/contractaccounts/").concat(contractAccountId, "/budgetbillingplans"));
}
function getBudgetBillingPlan(contractAccountId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/contractaccounts/").concat(contractAccountId, "/budgetbillingplans"));
}
function getAdjustmentDetails(contractAccountId, billingPlanItemId) {
  return _RestHelper.default.get("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/contractaccounts/").concat(contractAccountId, "/budgetbillingplans/").concat(billingPlanItemId));
}
var saveNewBudgetBillingPlan = exports.saveNewBudgetBillingPlan = function saveNewBudgetBillingPlan(contractAccountId, billingPlanItemId, data) {
  return _RestHelper.default.patch("".concat(_RestHelper.default.getBaseUrl(_RestHelper.MWDomains.cicCustomer), "/api/partner/v0/contractaccounts/").concat(contractAccountId, "/budgetbillingplans/").concat(billingPlanItemId), data).then(function (response) {
    _CacheHandler.default.saveCache({
      bbpSaveStatus: response.status
    });
    return response.data;
  }).catch(function (error) {
    throw error.response;
  });
};
var _default = exports.default = {
  getCurrentBudgetBillingPlan: getCurrentBudgetBillingPlan
};